import React from "react";
import styles from "./titles.module.css";
export const Title = ({ title, size }) => {
  return (
    <div style={{ fontSize: size }} className={`${styles.title}`}>
      {title}
    </div>
  );
};
